import { useFeatureFlagsStore } from '@/stores/feature-flags'

/**
 * Check if the leaderboard feature is enabled
 */
export function isLeaderboardEnabled(): boolean {
  return useFeatureFlagsStore().isFeatureEnabled('leaderboard')
}
